import React, { useEffect, useState } from 'react';
import { Button, Modal, Icon } from 'tea-component';
import { useIntl } from 'umi';
import { ModalPrposType } from './ModalWrap';
import '../index.scss';

export default function AccessDenied(props: ModalPrposType){
  const { close } = props;
  const { formatMessage } = useIntl();
  const [countDown, setCountDown] = useState(3);

  useEffect(()=> {
    const parentElement = document.querySelector('.dtb-db-layout .tea-layout__content');
    if (parentElement) {
      const newDiv = document.createElement('div');
      newDiv.classList.add('dbd-menu-access-denied-blank');
      parentElement.appendChild(newDiv);
    }
  },[]);

  useEffect(()=> {
    if(countDown > 0) {
      setTimeout(()=> {
        setCountDown(countDown - 1);
      }, 1000);
    } else {
      close();
    }
  },[close, countDown]);

  return (
    <>
      <Modal.Body>
        <div className="dbd-menu-access-denied">
          <Icon type="error" className='dbo-error-icon'/>
          <div className="dbd-menu-access-denied-content">
            <div className='access-denied-title'>{formatMessage({id: 'menu_access_denied'})}</div>
            <span>
              {formatMessage({id: 'menu_access_denied_tips'})}
            </span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={close}>{`${formatMessage({id: 'menu_access_denied_button'})} (${countDown})`}</Button>
      </Modal.Footer>
    </>
  );
}